import React from "react";
import { Tooltip, Whisper } from "rsuite";
import { getTextColor } from "utils/DashboardUtils";

/**
 * AppLabel - Display component for displaying a label
 *
 */
const AppLabel = ({ label, onClick, size = "sm", showWhisper = true }) => {
  const textColor = getTextColor(label?.Color);

  return (
    <>
      <Whisper
        placement="auto"
        trigger={label?.Description && showWhisper ? "hover" : "none"}
        speaker={<Tooltip>{label?.Description}</Tooltip>}
        delayOpen={400}
      >
        <div
          className="d-inline-block px-1 rounded text-center cursor-pointer"
          style={{
            backgroundColor: label?.Color,
            color: textColor,
            fontSize: 13,
            fontWeight: 500,
          }}
          onClick={onClick ? onClick : null}
        >
          {label?.Name}
        </div>
      </Whisper>
    </>
  );
};

export default AppLabel;
